import React, { useMemo } from 'react';
import * as styles from './styles/styles.module.scss';
import { contextPropTypes } from '../../../proptypes/shared';
import { LanguageSupportUtil } from '../../../utils/language_support_util';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const {
  strings: {
    SIGNUP: { SIGNUP },
    HOME_PAGE: { GET_PRO }
  }
} = StringConstantsMixin;

const MobileHomeLink = ({ context }) => {
  const [href, text] = useMemo(() => {
    if (!context.currentUser) {
      return [LanguageSupportUtil.wrapUrlSafe('/signup?ref=homepage_signup_mobileheader', context.languageRegionCode), SIGNUP];
    }

    if (!context.proUser) {
      return [LanguageSupportUtil.wrapUrlSafe('/pro?ref=homepage_pro_mobileheader', context.languageRegionCode), GET_PRO];
    }

    return [];
  }, [context]);

  return (
    <a className={styles.link} href={href}>
      {text}
    </a>
  );
};

MobileHomeLink.propTypes = {
  context: contextPropTypes.isRequired
};

export default MobileHomeLink;
